import React, { FC } from 'react';
import { css } from '@emotion/css';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';

interface DetailsItemProps {
  name: string;
  value: string;
  white?: boolean;
}

const DetailsItem: FC<DetailsItemProps> = (props) => {
  const { name, value } = props;
  const theme = useTheme();
  const styles = createStyles(theme, props);

  return (
    <div className={styles.root}>
      <div className={styles.name}>{name}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};

const createStyles = (theme: Theme, { white = false }: DetailsItemProps) => ({
  root: css`
    display: flex;
    align-items: center;
    background: ${white ? '#fff' : '#f6f8f9'};
    width: 100%;
    padding: 24px;
    height: 95px;
    border-top: 1px solid rgba(110, 124, 135, 0.2);
    ${theme.breakpoints.mobile.down} {
      flex-direction: column;
      align-items: start;
      justify-content: center;
      height: auto;
    }
  `,
  name: css`
    width: 50%;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: #6e7c87;
    ${theme.breakpoints.mobile.down} {
      width: 100%;
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 6px;
    }
  `,
  value: css`
    width: 50%;
    font-weight: 700;
    font-size: 24px;
    color: #252c32;
    ${theme.breakpoints.mobile.down} {
      width: 100%;
    }
  `,
});

export default DetailsItem;
